// extracted by mini-css-extract-plugin
export default {"item":"CardPlain-module--item--7a5d8","link":"CardPlain-module--link--8c6ee"};